import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function EuropeanShoppersPage() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-european-shoppers")!;
  return <ArticleLayout article={article} />;
}